import type { FaireProductEntity } from "../../entity_types/product";

export const p_qraervnhh3: FaireProductEntity = {
  token: "p_qraervnhh3",
  type: "product",
  name: "Simply Unscented Vegan & Sensitive Plastic Free Deodorant",
  brandToken: "b_axtc527c9j",
  brandName: "Humble Brands, Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/1b5a54b40ce4b7f6f1b488de54986bc72d12ad537b4832b633360c846528933e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8619225795233357dd34d3526024aa5664d96e8313e1e8c75aa8b693d29bdaed.jpeg",
    "https://cdn.faire.com/fastly/0d9d72dbfa1a0eebe15c48e4d93f1248a032478c58e5974c041fc7e90c51a1cf.jpeg",
    "https://cdn.faire.com/fastly/ee38a4c05f05804860065e3eb56dc8f2fde505aae451f9b7953e297664c9baf4.jpeg",
    "https://cdn.faire.com/fastly/344142fd451b5eac632b1f12b64cbbea4f7bcbc27c9c496c66177ae4e659d33e.jpeg",
    "https://cdn.faire.com/fastly/2b11fe4e1a76a10f0bb80f26c2e31df0230786410a751899ef68e5409716034e.jpeg",
    "https://cdn.faire.com/fastly/79144fa686596e2d6b80bf9b420e7f7e4bca31f54c43f74bd120b892c4d54f91.jpeg",
  ],
  priceDollars: 8.99,
  description:
    "Scent Note: No Fragrance, No Scent\n\nProduct Description: Made with simple, highly effective ingredients (MCT oil, non-GMO corn starch, beeswax, baking soda and botanically-based scents). Humble Brands Deodorant is formulated to absorb and neutralize body odor and has no aluminum, alcohol, dyes, parabens, sulfates or artificial fragrance. From the paperboard packaging to the ink and lining, Humble’s plastic-free deodorant will biodegrade in 2-5 months and is recyclable. Certified Cruelty-Free by Leaping Bunny and a 1% for the Planet product that gives back with every purchase.\n\nSize: 2.65 oz. / 75g",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:33.455Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
